/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_zoi__filters__ev_only = /** @type {(inputs: {}) => string} */ () => {
	return `Nur mit Ladestationen`
};

const en_zoi__filters__ev_only = /** @type {(inputs: {}) => string} */ () => {
	return `Only with EV stations`
};

const es_zoi__filters__ev_only = /** @type {(inputs: {}) => string} */ () => {
	return `Sólo con estaciones de carga`
};

const fr_zoi__filters__ev_only = /** @type {(inputs: {}) => string} */ () => {
	return `Uniquement avec stations de recharge`
};

const it_zoi__filters__ev_only = /** @type {(inputs: {}) => string} */ () => {
	return `Solo con stazioni di ricarica`
};

const nl_zoi__filters__ev_only = /** @type {(inputs: {}) => string} */ () => {
	return `Alleen met laadpalen`
};

const pt_zoi__filters__ev_only = /** @type {(inputs: {}) => string} */ () => {
	return `Apenas com estações de carregamento`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const zoi__filters__ev_only = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.zoi__filters__ev_only(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("zoi__filters__ev_only", locale)
	if (locale === "de") return de_zoi__filters__ev_only(inputs)
	if (locale === "en") return en_zoi__filters__ev_only(inputs)
	if (locale === "es") return es_zoi__filters__ev_only(inputs)
	if (locale === "fr") return fr_zoi__filters__ev_only(inputs)
	if (locale === "it") return it_zoi__filters__ev_only(inputs)
	if (locale === "nl") return nl_zoi__filters__ev_only(inputs)
	return pt_zoi__filters__ev_only(inputs)
};